export default __webpack_public_path__ + "src/images/home/ai_emails_screenshot-4a5036717ce52ef8504c5d2e1ba54251.png";